import { useParams } from 'react-router-dom';
import { AssetForm } from '~/components/assets/AssetForm';

export default function SiteAssetEdit() {
  const { siteId, assetId } = useParams();

  return (
    <div className='h-full overflow-hidden'>
      <AssetForm id={assetId} />
    </div>
  );
}
